"use client";

/**
 * Catálogo 2.3 — buscador (link), chips de categoría y grid de boots.
 */

import { useMemo, useState } from "react";
import Link from "next/link";

import { BottomNav, HeaderLogo } from "@/components/app/chrome";
import { IconoLupa } from "@/components/app/iconos";
import { ProductoCard } from "@/components/app/producto-card";
import type { ProductoApp } from "@/components/app/tipos";

export function CatalogoCliente({ productos }: { productos: ProductoApp[] }) {
  const categorias = useMemo(
    () => ["Todos", ...Array.from(new Set(productos.map((p) => p.categoria)))],
    [productos],
  );
  const [categoria, setCategoria] = useState("Todos");
  const filtrados =
    categoria === "Todos"
      ? productos
      : productos.filter((p) => p.categoria === categoria);

  return (
    <>
      <HeaderLogo />
      <main className="anim-bz-in min-h-(--alto-app) px-[17px] pt-[119px] pb-[62px]">
        <div className="pt-[22px] pb-[30px]">
          <Link
            href="/buscar"
            className="flex h-[52px] items-center gap-2.5 rounded-[26px] bg-humo px-5"
          >
            <IconoLupa color="rgba(34,31,31,.5)" />
            <span className="text-sm text-tinta/50">Buscar por fruta o beneficio</span>
          </Link>

          <div className="sin-scrollbar mt-[18px] flex gap-2 overflow-auto pb-1">
            {categorias.map((c) => {
              const activa = categoria === c;
              return (
                <button
                  key={c}
                  type="button"
                  onClick={() => setCategoria(c)}
                  className={`flex h-[38px] flex-none items-center rounded-[20px] px-[18px] font-app text-sm font-medium ${activa ? "bg-bosque text-white" : "bg-humo text-tinta"}`}
                >
                  {c}
                </button>
              );
            })}
          </div>

          <Link
            href="/packs"
            className="mt-4 flex items-center justify-between rounded-[22px] bg-bosque px-5 py-4"
          >
            <span>
              <span className="block font-app text-base font-semibold text-white">
                Pack variado
              </span>
              <span className="mt-0.5 block text-xs text-white/70">
                Combina tus sabores favoritos en packs de 7 o 14
              </span>
            </span>
            <span className="flex h-9 items-center rounded-[18px] bg-lima px-3.5 font-app text-[13px] font-semibold text-bosque">
              Armar
            </span>
          </Link>

          <p className="mt-5 text-[13px] text-tinta/50">
            {filtrados.length} boots · 210 g cada uno
          </p>

          <div className="mt-3.5 grid grid-cols-2 gap-4">
            {filtrados.map((p) => (
              <ProductoCard key={p.slug} producto={p} />
            ))}
          </div>
        </div>
      </main>
      <BottomNav />
    </>
  );
}
